import React from 'react';
import { Typography, Row, Col, Checkbox, Button } from 'antd';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { useTheme } from '../../../contexts/ThemeContext';
const { Text } = Typography;

// Componente recursivo para renderizar filhos em múltiplos níveis
const CategoryChildren = ({ 
  children, 
  selectedCategories, 
  checkedCategories,
  onToggleSelection, 
  onToggleExpansion,
  expandedCategories,
  color, 
  disabledCategories,
  level = 1 
}) => {
  if (!children || children.length === 0) return null;

  return (
    <div style={{ marginLeft: level * 24, marginBottom: 12 }}>
      <Row gutter={[12, 12]}>
        {children.map(child => {
          const childId = child.codCategoria || child.id;
          const hasGrandchildren = child.children && child.children.length > 0;
          const isExpanded = !!expandedCategories[childId];
          
          // Com hierarquia achatada, não há mais netos - todos são filhos diretos
          // Então removemos a renderização recursiva de CategoryCard
          
          // Se não tem netos, renderiza como ChildCategoryCard
          return (
            <Col xs={24} sm={12} md={8} key={childId}>
              <ChildCategoryCard
                child={child}
                isSelected={!!selectedCategories[childId] || !!checkedCategories[childId]}
                onToggleSelection={onToggleSelection}
                color={color}
                disabled={!!disabledCategories[childId]}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

const CategoryCard = ({ 
  category, 
  isSelected, 
  isIndeterminate, 
  isExpanded, 
  onToggleSelection, 
  onToggleExpansion,
  children,
  color,
  disabled,
  level = 0
}) => {
  const {theme} = useTheme();
  const categoryId = category.codCategoria || category.id;

  return (
    <div>
      {/* Card Principal */}
      <div
        style={{
          borderRadius: 8,
          padding: 8,
          marginBottom: 12,
          backgroundColor: theme.background,
          transition: 'all 0.3s',
          boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.7 : 1
        }}
        onClick={(e) => {
          // Só expande se clicar na área do texto, não no checkbox
          if (!e.target.closest('.ant-checkbox-wrapper') && !e.target.closest('.ant-checkbox')) {
            onToggleExpansion(categoryId);
          }
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div 
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Checkbox
                checked={isSelected}
                indeterminate={isIndeterminate}
                disabled={disabled}
                onChange={(e) => {
                  if (disabled) return;
                  e.stopPropagation();
                  onToggleSelection(category);
                }}
              />
            </div>
            <div>
              <Text style={{ 
                fontWeight: 500, 
                fontSize: 14,
                color: disabled ? theme.textSecondary : theme.black,
                display: 'block'
              }}>
                {category.nome || category.descricao}
              </Text>
              {category.children && category.children.length > 0 && (
                <Text style={{ 
                  fontSize: 12, 
                  color: '#8c8c8c' 
                }}>
                  {category.children.length} subcategorias
                </Text>
              )}
            </div>
          </div>
          
          {category.children && category.children.length > 0 && (
            <Button
              type="text"
              size="small"
              icon={isExpanded ? <DownOutlined /> : <RightOutlined />}
              onClick={(e) => {
                e.stopPropagation();
                onToggleExpansion(categoryId);
              }}
              style={{
                color: '#8c8c8c',
                fontSize: 12
              }}
            />
          )}
        </div>
      </div>

      {/* Cards dos Filhos */}
      {isExpanded && children}
    </div>
  );
};

const ChildCategoryCard = ({ 
  child, 
  isSelected, 
  onToggleSelection, 
  color,
  disabled
}) => {
  const {theme} = useTheme();
  const childId = child.codCategoria || child.id;

  return (
    <div
      style={{
        borderRadius: 6,
        padding: 8,
        backgroundColor: theme.background,
        transition: 'all 0.3s',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.7 : 1,
        height: '100%'
      }}
      onClick={(e) => {
        // Só executa se não clicar no checkbox
        if (!disabled && !e.target.closest('.ant-checkbox-wrapper') && !e.target.closest('.ant-checkbox')) {
          onToggleSelection(child);
        }
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
        <div 
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Checkbox
            checked={isSelected}
            disabled={disabled}
            style={{ marginTop: 1 }}
            onChange={(e) => {
              if (disabled) return;
              e.stopPropagation();
              onToggleSelection(child);
            }}
          />
        </div>
        <div style={{ flex: 1 }}>
          <Text style={{ 
            fontWeight: 400, 
            fontSize: 13,
            color: disabled ? theme.textSecondary : theme.black,
            lineHeight: '16px'
          }}>
            {child.nome || child.descricao}
          </Text>
        </div>
      </div>
    </div>
  );
};

export { CategoryCard, ChildCategoryCard, CategoryChildren }; 